import React from 'react';
import LegalLayout from './LegalLayout';

export default function AntiSpam() {
  return (
    <LegalLayout title="Анти-спам политика" updated="16 сентября 2026 года">
      <p>
        Настоящая Антиспам-политика (далее — «Политика») является неотъемлемой
        частью Лицензионного договора (Публичной оферты), заключённого между
        Индивидуальным предпринимателем Сидоренко Русланом Владимировичем (далее —
        «Лицензиар») и Пользователем Сервиса Mailora (далее — «Лицензиат»).
      </p>
      <p>
        Лицензиат, регистрируясь в Сервисе и/или начиная его использование,
        подтверждает своё полное и безоговорочное согласие с условиями настоящей
        Политики. Если Договор содержит указание или ссылку на Антиспам-политику,
        условия, изложенные в ней, являются неотъемлемой частью такого Договора.
      </p>
      <p>
        Лицензиар оставляет за собой право в любое время изменять настоящую
        Политику в одностороннем порядке. Актуальная версия Политики всегда
        доступна на Сайте по адресу https://mailora.ru/anti-spam. Лицензиат
        обязуется самостоятельно и регулярно отслеживать изменения. Продолжение
        использования Сервиса после внесения изменений означает полное согласие
        Лицензиата с такими изменениями.
      </p>

      <h2>1. Термины и определения</h2>
      <p>
        1.1. <strong>Договор</strong> — соглашение между Лицензиаром и Лицензиатом,
        условия которого регулируют предоставление права использования Сервиса.
      </p>
      <p>
        1.2. <strong>Сервис Mailora (Сервис)</strong> — принадлежащий Лицензиару
        программно-аппаратный комплекс, доступный через сеть Интернет по адресу
        https://mailora.ru, предназначенный для автоматизации email-аутрича и
        деловой переписки: подключение собственных почтовых ящиков, загрузка баз
        получателей, создание цепочек и авторассылок, настройка персонализации,
        встроенный инбокс, Telegram-уведомления, аналитика.
      </p>
      <p>
        1.3. <strong>Лицензиар</strong> — Индивидуальный предприниматель Сидоренко
        Руслан Владимирович, ОГРНИП 317619600088799, ИНН 611300126009.
      </p>
      <p>
        1.4. <strong>Лицензиат (Пользователь)</strong> — физическое или юридическое
        лицо, использующее Сервис на условиях Договора.
      </p>
      <p>
        1.5. <strong>База контактов Лицензиата</strong> — совокупность контактных
        данных (включая адреса электронной почты), используемая Лицензиатом для
        осуществления email-аутрича с помощью Сервиса. База контактов формируется
        Лицензиатом самостоятельно и загружается в Сервис.
      </p>
      <p>
        1.6. <strong>Электронное письмо (Письмо)</strong> — сообщение, отправляемое
        Лицензиатом одному или нескольким адресатам с использованием функционала
        Сервиса.
      </p>
      <p>
        1.7. <strong>B2B-аутрич (Аутрич)</strong> — целенаправленная и
        персонализированная деловая коммуникация, инициируемая Лицензиатом в адрес
        представителей юридических лиц или индивидуальных предпринимателей
        (B2B-сегмент) с целью установления деловых контактов, предложения
        сотрудничества, продуктов или услуг, имеющих отношение к профессиональной
        деятельности получателя. Аутрич предполагает использование контактных
        данных, полученных из открытых источников или собственных баз данных
        Лицензиата, при условии соблюдения этических норм и релевантности
        предложения.
      </p>
      <p>
        1.8. <strong>СПАМ</strong> — для целей настоящей Политики под СПАМом
        понимаются следующие действия:
      </p>
      <ul>
        <li>1.8.1. Массовая отправка Электронных писем коммерческого или некоммерческого характера широкому кругу лиц без учёта их профессиональной деятельности, интересов или потенциальной релевантности предложения (нецелевая рассылка);</li>
        <li>1.8.2. Отправка Электронных писем, содержащих ложную, недостоверную или вводящую в заблуждение информацию об отправителе, предмете сообщения или содержании предложения;</li>
        <li>1.8.3. Использование поддельных или недействительных обратных адресов электронной почты или имён доменов;</li>
        <li>1.8.4. Отправка Электронных писем без предоставления получателю ясной, функционирующей и легкодоступной возможности отказаться от получения подобных сообщений в будущем (отписаться);</li>
        <li>1.8.5. Email-аутрич, нарушающий требования применимого законодательства Российской Федерации (включая, но не ограничиваясь, ФЗ «О рекламе»), этические нормы делового оборота;</li>
        <li>1.8.6. Email-аутрич, приводящий к высокому уровню жалоб со стороны получателей, высокому показателю отказов (bounce rate) или попаданию IP-адресов/доменов Лицензиара или Лицензиата в чёрные списки (blacklists).</li>
      </ul>
      <p>
        1.9. <strong>Жалоба на СПАМ</strong> — любое из следующих событий:
      </p>
      <ul>
        <li>1.9.1. Сообщение от получателя (в том числе через механизм FBL — Feedback Loop) о нежелательности полученного Электронного письма;</li>
        <li>1.9.2. Блокировка IP-адресов или доменных имён, используемых для email-аутрича Лицензиата, почтовыми провайдерами или антиспам-сервисами;</li>
        <li>1.9.3. Превышение допустимых пороговых значений Показателей качества email-аутрича.</li>
      </ul>
      <p>
        1.10. <strong>Показатели качества email-аутрича</strong> — метрики,
        отслеживаемые Сервисом или почтовыми провайдерами, характеризующие качество
        email-аутрича Лицензиата. Рекомендуемые и/или предельно допустимые
        значения:
      </p>
      <ul>
        <li>1.10.1. Показатель отказов (Bounce Rate): не более 5%. Рассчитывается как отношение количества писем, не доставленных по причине несуществования адреса или иных перманентных ошибок, к общему числу отправленных писем;</li>
        <li>1.10.2. Количество жалоб на СПАМ (Complaint Rate): не более 0,1% (не более 1 жалобы на 1000 отправленных писем);</li>
        <li>1.10.3. Уровень отписок (Unsubscribe Rate): не более 1,5%, рассчитываемый как отношение числа отписок к числу первоначально отправленных сообщений;</li>
        <li>1.10.4. Показатель недействительности (Invalid Rate): не более 2%, рассчитываемый как отношение количества недействительных адресов к общему количеству отправленных писем;</li>
        <li>1.10.5. Попадания в спам-ловушки и необоснованные жалобы на злоупотребления: не допускаются.</li>
      </ul>
      <p>
        Лицензиар вправе корректировать эти показатели и уведомлять об этом
        Лицензиата.
      </p>

      <h2>2. Общие принципы и цели Политики</h2>
      <p>
        2.1. Настоящая Политика направлена на обеспечение использования Сервиса
        Лицензиатом для осуществления законного, этичного и эффективного
        B2B-аутрича, а не для распространения СПАМа.
      </p>
      <p>
        2.2. Лицензиат обязуется использовать Сервис таким образом, чтобы его
        действия не наносили ущерб репутации Лицензиара, Сервиса, а также не
        приводили к блокировке IP-адресов, доменов или иных ресурсов, используемых
        Сервисом.
      </p>
      <p>
        2.3. Лицензиар поддерживает практику персонализированных и релевантных
        коммерческих предложений в B2B-сегменте, направляемых на корпоративные
        адреса электронной почты, полученные из открытых и законных источников, при
        условии соблюдения Лицензиатом всех требований настоящей Политики и
        действующего законодательства РФ.
      </p>
      <p>
        2.4. Главным принципом является качество и релевантность коммуникации, а не
        её массовость.
      </p>

      <h2>3. Запрещённые действия и типы контента</h2>
      <p>3.1. Лицензиату категорически запрещается использовать Сервис для:</p>
      <p>
        3.1.1. Рассылки СПАМа в любом его проявлении, как оно определено в п. 1.8
        настоящей Политики.
      </p>
      <p>3.1.2. Отправки Электронных писем, содержащих:</p>
      <ul>
        <li>а) контент, который может быть расценен как оскорбительный, вредоносный, вводящий в заблуждение, мошеннический, недобросовестный, аморальный, непристойный, порнографический, расистский, этнически оскорбительный, угрожающий, чрезмерно жестокий, клеветнический, содержащий недостоверную информацию, разжигающий ненависть, ненормативную лексику;</li>
        <li>б) предложения, связанные с азартными играми, финансовыми пирамидами, схемами быстрого обогащения, незаконным оборотом наркотиков, оружия, лекарственных препаратов, отпускаемых по рецепту (если это не является законной деятельностью Лицензиата, и email-аутрич направлен на профильных специалистов);</li>
        <li>в) вредоносное программное обеспечение (вирусы, трояны, шпионское ПО и т.д.) или ссылки на него;</li>
        <li>г) информационные и/или рекламные материалы, нарушающие права интеллектуальной собственности (авторские права, товарные знаки и т.д.) Лицензиара и/или третьих лиц;</li>
        <li>д) информацию, направленную на введение в заблуждение получателей относительно личности отправителя, его принадлежности к какой-либо организации без наличия на то полномочий;</li>
        <li>е) утверждения о том, что email-аутрич осуществляется от имени Сервиса Лицензиара или самим Лицензиаром (за исключением служебных уведомлений от Сервиса).</li>
      </ul>
      <p>
        3.1.3. Использования Баз контактов, приобретённых или арендованных у
        третьих лиц, если происхождение и качество таких баз сомнительны или
        неизвестны, и нет уверенности в их релевантности для B2B-аутрича.
      </p>
      <p>
        3.1.4. Указания в качестве отправителя или обратного адреса электронной
        почты, не принадлежащих Лицензиату, или к которым у Лицензиата нет законного
        доступа.
      </p>
      <p>
        3.1.5. Сокрытия или фальсификации информации об отправителе в заголовках
        письма или его теле.
      </p>
      <p>
        3.1.6. Отправки Электронных писем без чёткого, легкодоступного и исправно
        работающего механизма отписки (например, ссылка «Отписаться» или инструкция,
        как это сделать).
      </p>
      <p>
        3.1.7. Email-аутрич, не имеющий очевидной связи с профессиональной
        деятельностью, должностными обязанностями или законными деловыми интересами
        B2B-получателей.
      </p>

      <h2>4. Требования к качеству email-аутрича и Базам контактов</h2>
      <p>
        4.1. Лицензиат несёт полную ответственность за качество и законность
        используемых им Баз контактов, а также за содержание отправляемых
        Электронных писем.
      </p>
      <p>4.2. При формировании Баз контактов и осуществлении email-аутрича Лицензиат должен стремиться к:</p>
      <ul>
        <li>4.2.1. Релевантности и таргетированности: сообщения должны быть адресованы представителям компаний, чья сфера деятельности или должностные обязанности предполагают потенциальный интерес к предложению Лицензиата;</li>
        <li>4.2.2. Персонализации: рекомендуется максимально персонализировать обращения, используя доступную информацию о компании-получателе или её представителе (например, имя, должность, название компании), чтобы продемонстрировать осведомлённость и серьёзность намерений;</li>
        <li>4.2.3. Актуальности данных: Лицензиат должен предпринимать разумные усилия для поддержания актуальности своей Базы контактов, регулярно очищая её от недействительных адресов. Сервис может предоставлять инструменты для верификации адресов;</li>
        <li>4.2.4. Чёткой идентификации отправителя: каждое Электронное письмо должно содержать ясную информацию о Лицензиате (наименование компании, контактные данные), позволяющую получателю идентифицировать отправителя;</li>
        <li>4.2.5. Предоставлению ценности: содержание письма должно быть лаконичным, понятным и нести потенциальную ценность для получателя в контексте его профессиональной деятельности.</li>
      </ul>
      <p>
        4.3. Лицензиат обязан следить за Показателями качества email-аутрича и не
        допускать их ухудшения сверх установленных в п. 1.10 пределов.
      </p>

      <h2>5. Мониторинг и превентивные меры со стороны Лицензиара</h2>
      <p>
        5.1. Лицензиар вправе осуществлять мониторинг email-аутрича Лицензиата (как
        автоматически, так и выборочно вручную) на предмет соблюдения настоящей
        Политики.
      </p>
      <p>
        5.2. Лицензиар использует автоматизированные системы для анализа
        email-аутрича, выявления признаков СПАМа, отслеживания Жалоб на СПАМ и
        Показателей качества email-аутрича.
      </p>
      <p>
        5.3. Лицензиар вправе проводить проверку данных, предоставленных Лицензиатом
        при регистрации, а также запрашивать дополнительную информацию о характере и
        источниках его Баз контактов и целях email-аутрича.
      </p>
      <p>
        5.4. Лицензиар может предоставлять Лицензиату обучающие материалы,
        рекомендации и консультации по вопросам этичного и эффективного B2B-аутрича
        через Сайт, Личный кабинет или службу поддержки.
      </p>
      <p>
        5.5. В случае выявления потенциальных нарушений или рисков Лицензиар вправе
        временно приостановить возможность осуществления email-аутрича Лицензиатом
        для проведения проверки.
      </p>

      <h2>6. Последствия нарушения Антиспам-политики</h2>
      <p>
        6.1. В случае выявления нарушений Лицензиатом настоящей Политики, а также
        при поступлении значительного числа Жалоб на СПАМ или существенном ухудшении
        Показателей качества email-аутрича Лицензиар вправе по своему усмотрению
        применить следующие меры:
      </p>
      <ul>
        <li>6.1.1. Направить Лицензиату предупреждение с требованием устранить нарушения в установленный срок;</li>
        <li>6.1.2. Временно приостановить или ограничить доступ Лицензиата к функциям Сервиса, связанным с осуществлением email-аутрича, до выяснения обстоятельств и устранения нарушений;</li>
        <li>6.1.3. В случае грубого или неоднократного нарушения настоящей Политики, а также в случае отказа Лицензиата устранить нарушения или предоставить запрошенную информацию, Лицензиар вправе расторгнуть Договор в одностороннем порядке и заблокировать учётную запись Лицензиата без возмещения уплаченного лицензионного вознаграждения, которое в данном случае удерживается в качестве штрафа за нарушение условий Договора и Политики.</li>
      </ul>
      <p>
        6.2. Лицензиар вправе осуществить блокировку email-аутрича или учётной
        записи Лицензиата немедленно и без предварительного уведомления в случаях,
        если действия Лицензиата создают угрозу для работоспособности Сервиса,
        репутации Лицензиара или могут повлечь за собой санкции со стороны почтовых
        провайдеров или государственных органов.
      </p>
      <p>
        6.3. Для снятия блокировки Лицензиат предоставляет Лицензиару документы,
        подтверждающие устранение нарушений, не позднее одного рабочего дня с момента
        блокировки, после чего Лицензиар вправе снять блокировку.
      </p>
      <p>
        6.4. Лицензиат соглашается, что несёт полную самостоятельную ответственность
        (административную, гражданско-правовую, уголовную) за любые нарушения
        законодательства РФ и прав третьих лиц, допущенные им при использовании
        Сервиса. Лицензиат обязуется возместить Лицензиару любые убытки (включая
        штрафы, судебные издержки и т.п.), понесённые Лицензиаром вследствие
        нарушения Лицензиатом настоящей Политики или действующего законодательства.
      </p>
      <p>
        6.5. Лицензиат согласен, что в случае блокировки функции отправки рассылок
        по любым основаниям возврат денежных средств Лицензиаром не осуществляется,
        денежные средства удерживаются в качестве штрафа. Для продолжения
        использования Сервиса Лицензиату необходимо осуществить оплату
        лицензионного вознаграждения согласно выбранному тарифу.
      </p>

      <h2>7. Заключительные положения</h2>
      <p>
        7.1. Настоящая Политика является неотъемлемой частью Лицензионного договора.
        Во всём, что не урегулировано настоящей Политикой, Стороны руководствуются
        положениями Договора и действующим законодательством Российской Федерации.
      </p>
      <p>
        7.2. Лицензиар призывает Лицензиатов придерживаться высоких этических
        стандартов при ведении B2B-аутрича и использовать Сервис ответственно.
      </p>
      <p>
        7.3. По вопросам, связанным с настоящей Политикой, Лицензиат может
        обращаться в службу поддержки Лицензиара по контактным данным, указанным на
        Сайте.
      </p>

      <h2>8. Реквизиты Лицензиара</h2>
      <p>
        Индивидуальный предприниматель Сидоренко Руслан Владимирович
        <br />
        ОГРНИП: 317619600088799
        <br />
        ИНН: 611300126009
        <br />
        Адрес электронной почты технической поддержки: support@mailora.ru
        <br />
        Адрес электронной почты для вопросов персональных данных: contact@mailora.ru
        <br />
        Режим работы: 9:00–18:00 МСК, за исключением праздничных и выходных дней.
        <br />
        Сайт: www.mailora.ru
      </p>

      <h2>Контакты</h2>
      <p>
        Сообщить о спаме:{' '}
        <a href="mailto:contact@mailora.ru">contact@mailora.ru</a>
      </p>
    </LegalLayout>
  );
}